export default {
    namespaced: true,
    state: {
        cart: [],
        model: 3,
        show_checkout: false,
    },
    getters: {
        model(state) {
            return state.model;
        },
        show_checkout(state) {
            return state.show_checkout;
        },
        cart(state) {
            return state.cart;
        },
        totalPrice(state) {
            return state.cart.reduce((total, item) => {
                return total + item.quantity * item.price;
            }, 0);
        },
        totalQuantity(state) {
            return state.cart.reduce((total, item) => {
                return total + item.quantity;
            }, 0);
        },
    },
    mutations: {
        addToCart(state, obj) {
            const result = state.cart.find((el) => el.id === obj.id);
            if (!result) {
                state.cart.push(obj);
            } else {
                // map existing add qty
                return state.cart.map((el) => {
                    if (el.id === obj.id) {
                        el.quantity += obj.quantity;
                    }
                });
            }
        },
        updateCart(state, obj) {
            return state.cart.map((el) => {
                if (el.id === obj.id) {
                    el.quantity = obj.quantity;
                }
            })
        },
        removeFromCart(state, itemId) {
            state.cart = state.cart.filter((item) => item.id !== itemId);
        },
        clearCart(state) {
            state.cart = [];
        },
        setCheckout(state, checkoutId) {
            state.model = checkoutId;
        },
        setView(state, is_show) {
            state.show_checkout = is_show;
        },
    },
    actions: {
        addToCartVuex({commit}, obj) {
            commit("addToCart", obj);
        },
        updateCartVuex({commit}, obj) {
            const cart = {
                id: obj?.id,
                quantity: obj?.quantity,
            };
            commit("updateCart", cart);
        },
        removeFromCartVuex({commit}, itemId) {
            commit("removeFromCart", itemId);
        },
        setCheckout({commit}, checkoutId) {
            commit("setCheckout", checkoutId);
        },
        setView({commit}, is_show) {
            commit("setView", is_show);
        },
        clearCartVuex({commit}) {
            commit("clearCart");
        },
    },
};
